module.exports = __webpack_public_path__ + "media/src/images/icons/file_types/xlsx-45b24f221a502002f5c4e5cea8b39910.svg";